import "./OrderComment.css";

import { MessageSquareMore } from "lucide-react";
import { useRef } from "react";

const MAX_COMMENT = 300;

export default function OrderComment({
  value,
  onChange,
}) {
  const remaining = MAX_COMMENT - value.length;
  const textareaRef = useRef(null);
  const handleChange = (e) => {
    onChange(e.target.value);

   // textareaRef.current.style.height = "auto";

   // textareaRef.current.style.height = textareaRef.current.scrollHeight + "px";
  };

  return (
    <div className="order-comment-card">
      <div className="order-comment-header">
        <MessageSquareMore size={22} />

        <div>
          <h3>توضیحات سفارش</h3>

          <p>در صورت نیاز توضیحات خود را برای واحد ارسال وارد کنید.</p>
        </div>
      </div>

      <textarea ref={textareaRef} value={value}
       onChange={handleChange} cols="48" className="comment-textarea"/>

      <div className="order-comment-footer">
        <span className="comment-help">
          این توضیحات همراه سفارش ثبت خواهد شد.
        </span>

        <span
          className={`comment-counter
                    ${
                      remaining <= 20
                        ? "danger"
                        : remaining <= 60
                          ? "warning"
                          : ""
                    }`}
        >
          {value.length}/{MAX_COMMENT}
        </span>
      </div>
    </div>
  );
}
